import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
const defaultOptions = {} as const;

export const SalesPortalUpdateAccountDocument = gql`
  mutation SalesPortalUpdateAccount(
    $supplierUUID: uuid!
    $restaurantUUID: uuid!
    $name: String
    $address: String
    $address2: String
    $accountId: String
    $routeStop: String
    $note: String
  ) {
    supplierUpdateRestaurant(
      supplier_id: $supplierUUID
      restaurant_id: $restaurantUUID
      restaurant_name: $name
      restaurant_address: $address
      restaurant_address2: $address2
      restaurant_account_id: $accountId
      route_stop: $routeStop
      restaurant_notes: $note
    ) {
      restaurant_id
    }
  }
`;
export type SalesPortalUpdateAccountMutationFn = Apollo.MutationFunction<
  Types.SalesPortalUpdateAccountMutation,
  Types.SalesPortalUpdateAccountMutationVariables
>;
export function useSalesPortalUpdateAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.SalesPortalUpdateAccountMutation,
    Types.SalesPortalUpdateAccountMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.SalesPortalUpdateAccountMutation,
    Types.SalesPortalUpdateAccountMutationVariables
  >(SalesPortalUpdateAccountDocument, options);
}
export type SalesPortalUpdateAccountMutationHookResult = ReturnType<
  typeof useSalesPortalUpdateAccountMutation
>;
export type SalesPortalUpdateAccountMutationResult =
  Apollo.MutationResult<Types.SalesPortalUpdateAccountMutation>;
export type SalesPortalUpdateAccountMutationOptions =
  Apollo.BaseMutationOptions<
    Types.SalesPortalUpdateAccountMutation,
    Types.SalesPortalUpdateAccountMutationVariables
  >;
